import { combineReducers } from 'redux';
import itemsDataReducerFor from './common/itemsDataReducerFor';
import filtersReducerFor from './common/filtersReducerFor';
import statusReducerFor from './common/statusReducerFor';

const rolesReducers = combineReducers({
  rolesData: itemsDataReducerFor('ROLES_'),
  rolesFilters: filtersReducerFor('ROLES_'),
  rolesStatus: statusReducerFor('ROLES_'),
});

export default rolesReducers;
